import React from "react";
import { observer } from "mobx-react";
import { Confirm, Image, Icon, Modal, Card } from "semantic-ui-react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ValidationMessage from "./ValidationMessage";
import Immersive3dTourPanoramaModel from "../../models/Immersive3dTourPanorama";

@observer
class Immersive3dTourPanorama extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmDialog: false,
      openErrorsModal: false,
    };
  }

  onDeleteConfirm() {
    const { panorama, deletePanoramaCallback } = this.props;

    deletePanoramaCallback(panorama.id);

    this.closeDeleteConfirm();
  }

  openDeleteConfirm() {
    this.setState({ openConfirmDialog: true });
  }

  closeDeleteConfirm() {
    this.setState({ openConfirmDialog: false });
  }

  openErrorsModal() {
    this.setState({ openErrorsModal: true });
  }

  closeErrorsModal() {
    this.setState({ openErrorsModal: false });
  }

  render() {
    const {
      panorama,
      panoramaIndex,
      openProcessingImageModalCallback,
      thumbnails,
      selectedPanoramasCount,
    } = this.props;
    const { openConfirmDialog, openErrorsModal } = this.state;

    let image = <div className="immersive3dTourPanoramaImageNotShown" />;

    if (typeof thumbnails[panorama.upload.id] !== "undefined") {
      image = <Image src={URL.createObjectURL(thumbnails[panorama.upload.id])} wrapped ui={false} />;
    } else if (typeof thumbnails[panorama.id] !== "undefined") {
      image = <Image src={thumbnails[panorama.id]} wrapped ui={false} />;
    }

    return (
      <div>
        <div className="immersive3dTourPanoramaMessage">
          {panorama.isSelected && <Icon name="check circle outline" />}
          <Icon
            name="edit outline"
            onClick={event => {
              event.stopPropagation();
              openProcessingImageModalCallback(panorama.url);
            }}
          />
          <Icon
            name="trash alternate outline"
            onClick={event => {
              event.stopPropagation();
              this.openDeleteConfirm();
            }}
          />
          {panorama.hasValidationMessages ? (
            <Icon
              name="warning sign"
              className={classNames("immersive3dTourPanoramaMessage", {
                hasError: panorama.hasErrors,
                hasWarning: panorama.hasWarnings && !panorama.hasErrors,
              })}
              onClick={() => this.openErrorsModal()}
            />
          ) : null}
        </div>
        {image}
        <Card.Content extra>
          {`#${panoramaIndex}`}&nbsp;
          {panorama.upload.name}
        </Card.Content>
        <Confirm
          open={openConfirmDialog}
          content="Image will be deleted. Do you want to continue?"
          onCancel={() => this.closeDeleteConfirm()}
          onConfirm={() => this.onDeleteConfirm()}
        />
        <Modal
          open={openErrorsModal}
          onClose={() => {
            this.closeErrorsModal();
          }}
        >
          <Modal.Header>Messages for this image</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {panorama.validationMessage.map((validationMessage, validationMessageIndex) => {
                // eslint-disable-next-line react/no-array-index-key
                return <ValidationMessage key={validationMessageIndex} message={validationMessage} />;
              })}
            </Modal.Description>
          </Modal.Content>
        </Modal>
        {selectedPanoramasCount >= 2 && <span className="selected-panoramas-count">{selectedPanoramasCount}</span>}
      </div>
    );
  }
}

Immersive3dTourPanorama.propTypes = {
  panorama: PropTypes.instanceOf(Immersive3dTourPanoramaModel),
  panoramaIndex: PropTypes.number,
  deletePanoramaCallback: PropTypes.func.isRequired,
  openProcessingImageModalCallback: PropTypes.func.isRequired,
  thumbnails: PropTypes.object.isRequired,
  selectedPanoramasCount: PropTypes.number.isRequired,
};

export default Immersive3dTourPanorama;
